<script lang="ts">
	import { stores$ } from '$lib/serv/groc-landing';
	import { extractErrorMessage } from '$lib/util/format';
	import { query } from '$lib/util/url';

	import StoreOption from '$lib/ui/layout/StoreOption.svelte';

	export let currentPageUrl: URL;
	export let selected = () => {};
</script>

<div class="address">
	{#if stores$}
		{@const stores = $stores$}
		{#if !stores || stores.loading}
			<p class="body-m book">Loading..</p>
		{:else if stores.error}
			<p class="body-m book">{extractErrorMessage(stores.error, 'Unable to load stores. Please try again.')}</p>
		{:else if stores.payload?.length}
			{@const q = query(currentPageUrl)}
			{@const urlStore = q.get('store')}

			{#each stores.payload as store, index}
				<div>
					<a href={q.set('store', store.id).toUrl(currentPageUrl)} data-testid={`store-option-${index}`} on:click={() => selected()} data-sveltekit-noscroll>
						<StoreOption {store} selected={urlStore ? store.id === urlStore : store.default} />
					</a>
				</div>
			{/each}
		{/if}
	{/if}


</div>
